// The UI language is only what the dispatcher reads in the app. It is not
// `preferredLanguage` on the account users node (the language they write in,
// used for message translation) and not the driver's language.
export type UiLanguage = "en" | "pl"

export const UI_LANGUAGES: readonly UiLanguage[] = ["en", "pl"]

// Users without a saved choice (or without the `ui-language` flag) must see
// today's UI word for word, and some screens are Polish today. This code
// carries only those Polish strings; every other key falls back to `en`.
// "pl" gives the legacy keys Polish plural rules; "ZZ" is an unassigned region.
export const LEGACY_LANGUAGE = "pl-ZZ" as const

export type I18nLanguage = UiLanguage | typeof LEGACY_LANGUAGE

export function isUiLanguage(value: unknown): value is UiLanguage {
  return UI_LANGUAGES.includes(value as UiLanguage)
}

export function resolveI18nLanguage(
  flagEnabled: boolean | undefined,
  uiLanguage: string | undefined,
): I18nLanguage {
  if (flagEnabled !== true || !isUiLanguage(uiLanguage)) return LEGACY_LANGUAGE
  return uiLanguage
}

export function htmlLangFor(language: I18nLanguage): "en" | "pl" {
  return language === "pl" ? "pl" : "en"
}
